const data: string = "<md-toast class=\"success\"><span cms-html=\"forgot-devices:components/ooba-domain\"></span></md-toast>";
export default data